/**
 * @Description 拓店-标准版本-加盟商
 */

import { get, post } from '@/common/request/index';

/**
 * @description 加盟商列表
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/65519
 */
export function franchiseePage(params?:any) {
  return post('/standard/franchisee/page', { ...params }, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * @description 加盟商搜索
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/92750
 */
export function getFranchiseeSearch(params?:any) {
  return post('/standard/franchisee/search', { ...params }, { isMock: false, mockId: 532, needHint: true });
}

/**
 * @description 加盟商动态表头
 * @yapi https://yapi.lanhanba.com/project/644/interface/api/98212
 */
export function getFranchiseeDynamicPageHeader(params?:any) {
  return get('/standard/franchisee/dynamic/headers', { ...params }, {
    isMock: false,
    mockId: 644,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * @description 动态表头列表
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/65967
 */
export function franchiseeDynamicPage(params?:any) {
  const { isYiMing, ...requestParams } = params || {};
  delete requestParams.isDynamicHeaders;
  return post(isYiMing ? '/standard/franchisee/dynamic/esPage' : '/standard/franchisee/dynamic/page', { ...requestParams }, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * @description 导出加盟商
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/89507
 */
export function franchiseeExport(params?:any) {
  return post('/standard/franchisee/export', { ...params }, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * @description 删除加盟商
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/75347
 */
export function franchiseeDelete(params?:any) {
  return post('/standard/franchisee/delete', { ...params }, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * @description 加盟商公海分页列表
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/100764
 */
export function franchiseePublicSeaPage(params?:any) {
  return post('/standard/franchisee/publicSea/page', { ...params }, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * @description 领取加盟商公海客户
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/100566
 */
export function franchiseePublicSeaClaim(params?:any) {
  return post('/standard/franchisee/publicSea/claim', { ...params }, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * @description 激活加盟商公海客户
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/100572
 */
export function franchiseePublicSeaActivate(params?:any) {
  return post('/standard/franchisee/publicSea/activate', { ...params }, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * @description 加盟商状态选项
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/65981
 */
export function getFranchiseeSelection(params?:any) {
  return post('/standard/franchisee/selection', { ...params }, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * @description 加盟商详情
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/65540
 */
export function getFranchiseeDetail(params?:any) {
  return post('/standard/franchisee/detail', { ...params }, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
    needCancel: false,
  });
}

/**
 * @description 加盟商模版列表
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/65526
 */
export function getFranchiseeTemplateList() {
  return post('/standard/franchisee/template/list', {}, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * @description 加盟商模版详情
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/65533
 */
export function franchiseeTemplateDetail(params:any) {
  return post(`/standard/franchisee/template/query`, params, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * @description 加盟商保存
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/59422
 */
export function saveFranchisee(params:any) {
  return post(`/standard/franchisee/save`, params, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * @description 状态变更记录列表
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/65841
 */
export function franchiseeStatusRecord(params:any) {
  return post(`/standard/franchisee/status/record`, params, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * 加盟商-移交
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/92727
 */
export function postFranchiseeTransfer(params:any) {
  return post('/standard/franchisee/transfer', params, { isMock: false, mockId: 532, needHint: true });
}

/**
 * 加盟商归属人共享 / 取消共享
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/99576
 */
export function postFranchiseeShare(params:any) {
  return post('/standard/franchisee/affiliation/share', params, { isMock: false, mockId: 532, needHint: true });
}

/**
 * @description 获取加盟线索导入模板
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/100620
 */
export function getClueImportTemplate(params?: any) {
  return get('/standard/franchisee/lead/template', params, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * @description 导入加盟线索
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/100578
 */
export function importClue(params: any) {
  return post('/standard/franchisee/lead/import', params, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * @description 加盟商公海-导出
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/100770
 */
export function franchiseePublicSeaExport(params?: any) {
  return post('/standard/franchisee/publicSea/export', params, { isMock: false, mockId: 532, needHint: true });
}

/**
 * @description 新增加盟商跟进记录
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/100548
 */
export function postFranchiseeFollowRecordAdd(params: any) {
  return post('/franchisee/followRecord/add', params, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}

/**
 * @description 加盟商跟进记录分页列表
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/100554
 */
export function postFranchiseeFollowRecordPage(params: any) {
  return post('/franchisee/followRecord/page', params, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
    needCancel: false,
  });
}

/**
 * @description 查询加盟商的推荐机会点列表（实时计算，最多 3 条，按推荐度降序）
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/100944
 */
export function getFranchiseeRecommendOppList(params: any) {
  return post('/ym/franchisee/recommendOpp/list', params, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
    needCancel: false,
  });
}

/**
 * @description 将加盟商关联到机会点所属的拓店任务
 * @yapi https://yapi.lanhanba.com/project/532/interface/api/100950
 */
export function associateFranchiseeToTask(params: any) {
  return post('/ym/franchisee/recommendOpp/associate', params, {
    isMock: false,
    mockId: 532,
    mockSuffix: '/api',
    needHint: true,
  });
}
